import { Application } from "@hotwired/stimulus";
import { registerPoetryControllers } from "@poetry/controllers";

const application = Application.start();
// Configure Stimulus development experience
application.debug = document.documentElement.classList.contains("debug");
window.Stimulus = application;

// The ui_kit components (Poetry)
registerPoetryControllers(application);

const controllers = import.meta.glob("./**/*_controller.js", { eager: true });

for (const [path, module] of Object.entries(controllers)) {
  const name = path
    .replace(/^.\//, "")
    .replace("/", "--")
    .replace(/_controller\.js$/, "");
  application.register(name, module.default);
}
